import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
    const { pathname, search, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const id = hash.replace("#", "");
            const target = document.getElementById(id);

            if (target) {
                requestAnimationFrame(() => {
                    target.scrollIntoView();
                });
            }

            return;
        }

        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [hash, pathname, search]);

    return null;
};
